<template>
    <div class="root">
        <v-subheader class="pl-0 title">
            {{$vuetify.t('$vuetify.ticketsets.chooseTicketsets')}}

            <v-btn
                absolute small dark
                fab right color="primary"
                v-if="countSelected > 0"
                @click="done"
            >
                <v-icon>done</v-icon>
            </v-btn>
        </v-subheader>

        <!-- Chekpoint block -->
        <v-list v-if="$store.state.activeCheckpoint !== null">
            <v-list-tile color="primary" class="pt-2 pb-2">
                <v-list-tile-action @click="checkpointSelectAll">
                    <v-checkbox v-model="checkpointSelectAllActive"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content
                    @click.prevent="checkpointSelectAllActive = !checkpointSelectAllActive; checkpointSelectAll()"
                >
                    <v-list-tile-title>{{$vuetify.t('$vuetify.ticketsets.selectAll')}}</v-list-tile-title>
                    <v-list-tile-sub-title>
                        {{$vuetify.t('$vuetify.ticketsets.ticketCount')}}
                        {{checkpointCountSelectedTickets}}
                    </v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile
                class="pb-2 pt-2"
                v-for="ticketset in checkpointTicketsets"
                :key="ticketset.id"
            >
                <v-list-tile-action>
                    <v-checkbox v-model="ticketset.selected"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="ticketset.selected = !ticketset.selected">
                    <v-list-tile-title v-text="ticketset.name"></v-list-tile-title>
                    <v-list-tile-sub-title>{{$vuetify.t('$vuetify.ticketsets.ticketCount')}} {{ ticketset.ticketCount }}</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>

        <!-- Event block -->
        <v-list v-if="$store.state.activeCheckpoint === null">
            <v-list-tile color="primary" class="pt-2 pb-2">
                <v-list-tile-action @click="selectAll">
                    <v-checkbox v-model="selectAllActive"></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="selectAllActive = !selectAllActive; selectAll()">
                    <v-list-tile-title>{{$vuetify.t('$vuetify.ticketsets.selectAll')}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{$vuetify.t('$vuetify.ticketsets.ticketCount')}} {{countSelectedTickets}}</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>

            <div
                v-for="event in getEvents"
                :key="event.id"
            >
                <v-divider></v-divider>
                <h3 class="mt-3 mb-1 ml-3">
                    {{ event.name }}
                    ({{ event.startAt | moment('D.M.YYYY') }})
                </h3>

                <v-list-tile
                    class="pb-2 pt-2"
                    v-for="ticketset in event.ticketsets"
                    :key="ticketset.id"
                >
                    <v-list-tile-action>
                        <v-checkbox v-model="ticketset.selected"></v-checkbox>
                    </v-list-tile-action>

                    <v-list-tile-content @click.prevent="ticketset.selected = !ticketset.selected">
                        <v-list-tile-title v-text="ticketset.name"></v-list-tile-title>
                        <v-list-tile-sub-title>{{$vuetify.t('$vuetify.ticketsets.ticketCount')}} {{ ticketset.count }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </div>
        </v-list>

    </div>
</template>

<script>
    import {initSound} from '../libs/utils'

    export default {
        data() {
            return {
                selectAllActive: false,
                checkpointSelectAllActive: false
            }
        },

        components: {},

        methods: {
            selectAll () {
                this.getTicketsets.forEach(ticketset => ticketset.selected = this.selectAllActive)
                // this.$store.state.events.forEach(event => {
                //     event.ticketsets.forEach(ticketset => ticketset.selected = this.selectAllActive)
                // })
            },

            checkpointSelectAll () {
                const checkpoint = this.$store.state.checkpoints.find(item => item.id === this.$store.state.activeCheckpoint)
                return checkpoint.ticketsets.forEach(ticketset => {
                    ticketset.selected = this.checkpointSelectAllActive
                })
            },

            done () {
                // const selectedIds = this.getTicketsets.reduce( (acc, ticketset) => {
                //     if (ticketset.selected) {
                //         acc.push(ticketset.id)
                //     }
                //     return acc
                // }, [])
                // this.$store.commit('setActiveTicketsets', selectedIds)
                initSound(this.$store)
                this.$router.push({name:'scanner'})
            }
        },

        computed: {
            getEvents() {
                return this.$store.state.activeEvents.map(id => this.$store.getters['eventById'](id))
            },
            getTicketsets() {
                return this.$store.state.activeEvents
                    .map(id => this.$store.getters['eventById'](id))
                    .reduce( (acc, event) => {
                        return [...acc, ...event.ticketsets]
                    }, [])
            },
            countSelected() {
                if (this.$store.state.activeCheckpoint !== null) {
                    return this.checkpointCountSelectedTickets
                } else {
                    return this.getTicketsets.reduce( (acc, ticketset) => {
                        if (ticketset.selected) {
                            acc++
                        }
                        return acc
                    }, 0)
                }
            },
            countSelectedTickets() {
                return this.getTicketsets.reduce( (acc, ticketset) => {
                    if (ticketset.selected) {
                        acc += ticketset.count
                    }
                    return acc
                }, 0)
            },
            checkpointTicketsets() {
                return this.$store.state.checkpoints.find(item => item.id === this.$store.state.activeCheckpoint).ticketsets
            },
            checkpointCountSelectedTickets() {
                const checkpoint = this.$store.state.checkpoints.find(item => item.id === this.$store.state.activeCheckpoint)
                return checkpoint.ticketsets.reduce( (acc, ticketset) => {
                    if (ticketset.selected) {
                        acc += ticketset.ticketCount
                    }
                    return acc
                }, 0)
            }
        },

        created() {
            // this.$store.dispatch('loadTicketsets', this.$store.state.activeEvent.id)
        }
    }
</script>

<style lang="scss" scoped>
</style>
